import {validateMaxLength} from '../../common/validationUtils';
import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";

export const validate = values => {
    let errors = {};
    const requiredFields = [
        'name',
        'countryId',
        'regionId',
        'municipalityId',
        'addressId',
        'city',
        'postalCode',
        'addressId'
    ];

    requiredFields.forEach(function (requiredField) {
        if (!values[requiredField]) {
            errors[requiredField] = plainJSTranslator.formatMessage(messages.required);
        }
    });

    [
        'additionalInformation',
        'registrationLink',
    ].forEach(function (urlFieldName) {
        if(values[urlFieldName] && !isValidUrl(values[urlFieldName])) {
            errors[urlFieldName] = plainJSTranslator.formatMessage(messages.mustStartWithHTTP);
        }
    });

    if(values.amount ) {
        if(values.amount > 1000000000) {
            errors.amount = plainJSTranslator.formatMessage(messages.priceTooHigh);
        }
    }

    if(!values.description.replace(/\s|&nbsp;|(<([^>]+)>)/g, '')) {
        errors.description = plainJSTranslator.formatMessage(messages.required);
    }

    errors = validateMaxLength({values, errors, length: 255, fields: [
        'name',
        'city',
        'youtube-link',
        'additionalInformation',
        'registrationLink',
    ]});

    return errors;
};

function isValidUrl(value) {
    return value.match(/^https?:\/\//);
}


// WEBPACK FOOTER //
// ./web/src/components/venues-and-courses/validate.js